<template>
   <div class="max-w-3xl">
        <Video :comp-object="object" />
       {{ object }}
   </div>
</template>

<script>
import Video from '@/components/Video.vue'
export default {
   name: "VideoObject",
   props: ['object'],
   components: { Video },
   computed: {},
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
